import { Chip, Grid, Menu, MenuItem } from "@mui/material";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { MouseEvent } from "react";

type Props = {
  hasDateRange: boolean;
  exportAnchorEl: Element | null;
  onOpenExportMenu: (event: MouseEvent<Element>) => void;
  onCloseExportMenu: () => void;
  onExcelExport: () => void;
  onQuickbooksExport?: () => void;
  quickbooksExportDisabled?: boolean;
  JobPhaseFilter: () => JSX.Element;
  UserFilter: () => JSX.Element;
  DateFilter: () => JSX.Element;
  ViewModeSwitch: () => JSX.Element;
};

export default function TimeEntriesTableFilters({
  hasDateRange,
  exportAnchorEl,
  onOpenExportMenu,
  onCloseExportMenu,
  onExcelExport,
  onQuickbooksExport,
  quickbooksExportDisabled = false,
  JobPhaseFilter,
  UserFilter,
  DateFilter,
  ViewModeSwitch,
}: Props) {
  return (
    <Grid container spacing={1.5} alignItems="center" justifyContent="center">
      <Grid item xs={12} sm={2.5}>
        <JobPhaseFilter />
      </Grid>
      <Grid item xs={12} sm={2.5}>
        <UserFilter />
      </Grid>
      <Grid item xs={12} sm={4}>
        <DateFilter />
      </Grid>
      <Grid item xs={12} sm={1.5}>
        <ViewModeSwitch />
      </Grid>
      <Grid item xs={12} sm={1.5}>
        <MDBox display="flex" justifyContent="flex-end">
          <span onClick={onOpenExportMenu} style={{ width: "100%" }}>
            <MDButton
              variant="outlined"
              color="info"
              disabled={!hasDateRange}
              fullWidth
              sx={{ minHeight: "34px", py: 0.25, fontSize: "0.75rem", whiteSpace: "nowrap" }}
              endIcon={<Icon>arrow_drop_down</Icon>}
            >
              Export
            </MDButton>
          </span>
          <Menu anchorEl={exportAnchorEl} open={Boolean(exportAnchorEl)} onClose={onCloseExportMenu}>
            <MenuItem onClick={onExcelExport}>Excel</MenuItem>
            {onQuickbooksExport && (
              <MenuItem onClick={onQuickbooksExport} disabled={quickbooksExportDisabled}>
                <MDBox display="flex" alignItems="center" gap={1}>
                  <span>QuickBooks Online</span>
                  <Chip label="Beta" size="small" color="warning" variant="outlined" />
                </MDBox>
              </MenuItem>
            )}
          </Menu>
        </MDBox>
      </Grid>
    </Grid>
  );
}
